import {
  FlexBoxImageScaleView,
  FlexBoxView,
} from '@play-co/timestep-core/flexbox';
import { GachaItem } from 'src/replicant/gacha/gacha.ruleset';
import { getGachaRewardIcon } from '../gacha.util';

export class GachaResultItem extends FlexBoxView {
  constructor(item: GachaItem, multiple = false) {
    super({
      flex: {
        flexDirection: 'column',
        minWidth: 106,
        maxWidth: 300,
        minHeight: multiple ? 142 : 344,
        flexShrink: 1,
        flexGrow: 1,
        alignItems: 'stretch',
        justifyContent: 'center',
        alignSelf: 'stretch',
        marginVertical: 5,
        marginHorizontal: 5,
      },
    });

    const image = getGachaRewardIcon(item);

    // Item View
    new FlexBoxImageScaleView({
      superview: this,
      image,
      scaleMethod: 'contain',
      flex: {
        maxWidth: 300,
        maxHeight: 287,
        minWidth: 106,
        minHeight: 101,
        flexShrink: 1,
        flexGrow: 1,
      },
    });

    // Stars container
    const starsContainer = new FlexBoxView({
      superview: this,
      flex: {
        maxWidth: 300,
        maxHeight: 39,
        minWidth: 106,
        minHeight: 26,
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 1,
        flexGrow: 1,
        marginTop: 5,
      },
    });

    // Add stars to container
    for (let i = 0; i < item.tier; i++) {
      new FlexBoxImageScaleView({
        superview: starsContainer,
        image: 'assets/ui/gacha/icons/star.png',
        scaleMethod: 'contain',
        flex: {
          width: multiple ? 26 : 39,
          height: multiple ? 26 : 39,
          marginHorizontal: 5,
        },
      });
    }
  }
}
